"use client";

import { Heart } from "lucide-react";
import { useMemo } from "react";
import { useUi } from "@/components/ui/use-ui";
import { useCamFavorite } from "@/lib/cam-favorites";
import { cn } from "@/lib/cn";

/** A cam model's heart: in the visitor's favourite models or not (lib/cam-favorites.ts). `large`: the model's page's button, with words. */
export function FavoriteCamButton({
  source,
  username,
  name,
  avatar,
  large,
  className,
}: {
  source: string;
  username: string;
  name: string;
  avatar: string | null;
  large?: boolean;
  className?: string;
}) {
  const t = useUi();
  const model = useMemo(() => ({ source, username: username.toLowerCase(), name, avatar }), [source, username, name, avatar]);
  const [on, toggle] = useCamFavorite(model);
  const label = on ? t.notifications.removeFavorite : t.notifications.addFavorite;
  if (large) {
    return (
      <button
        type="button"
        onClick={toggle}
        aria-pressed={on}
        className={cn("chip inline-flex h-11 items-center gap-2 rounded-full px-4 text-[14px] transition-colors", on ? "text-brand-soft" : "text-soft hover:text-fg", className)}
      >
        <Heart size={18} className={cn(on && "fill-brand text-brand")} />
        {label}
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={on}
      aria-label={`${label}: ${name}`}
      title={label}
      className={cn("grid size-7 shrink-0 place-items-center rounded-full transition-colors hover:bg-white/10", on ? "text-brand" : "text-muted hover:text-fg", className)}
    >
      <Heart size={16} className={cn("transition-transform active:scale-90", on && "fill-brand")} />
    </button>
  );
}
